var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE1Mezzanine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 55V28.8L21 14.28 0 29.11V59h76v-4H42zm-4-21h-9v7h-8v7h-8v7H4V31.22l17-12 17 11.69V34z",
    fill: "#040404"
  })));
}
export default __webpack_public_path__ + "static/media/E1_Mezzanine.5b29536d.svg";
export { SvgE1Mezzanine as ReactComponent };